module.exports = __webpack_public_path__ + "static/media/our-map-mobile.cf475460.webp";